export const EXCMCASETYPE_SHOW_RESET = 'EXCMCASETYPE_SHOW_RESET'
export const EXCMCASETYPE_SHOW_SET_ERROR = 'EXCMCASETYPE_SHOW_SET_ERROR'
export const EXCMCASETYPE_SHOW_SET_RETRIEVED = 'EXCMCASETYPE_SHOW_SET_RETRIEVED'
export const EXCMCASETYPE_SHOW_TOGGLE_LOADING = 'EXCMCASETYPE_SHOW_TOGGLE_LOADING'
